// extracted by mini-css-extract-plugin
export default {"maxLengthError":"TagsForm_maxLengthError__LZUbp"};